export const USER_KEY = 'user-key'
export const API_URL = import.meta.env.VITE_PUBLIC_API_URL

export const ROUTES = {
  homepage: '/',
  login: '/login',
  authLogin: '/auth/login',
  signup: '/sign-up',
  onboarding: '/onboarding',
  accessDenied: '/403',
  notFound: '/404',
  logout: '/auth/logout',
  me: '/me',
  oauthConsent: '/oauth/consent',
}

export const PRIVATE_ROUTES: Array<string | RegExp> = [
  ROUTES.me,
  ROUTES.onboarding,
  ROUTES.oauthConsent,
]

export const WEBSITE_LINKS = {
  edpCampaign: 'https://edp.mydra.io',
  privacyPolicy: 'https://www.mydra.io/privacy-policy',
  termsAndConditions: 'https://www.mydra.io/terms-conditions',
  mydraWebsite: 'https://www.mydra.io/',
  aboutUs: 'https://www.mydra.io/about-us',
  educationProviders: 'https://www.mydra.io/education-providers',
  sevenStepAIFramework: 'https://www.mydra.io/7-step-ai-framework',
  fixPayFAQS: 'https://www.mydra.io/fixpay-faqs',
  faqs: 'https://mydra.helpscoutdocs.com',
  edpFAQs: 'https://training.mydra.io/partners/edp-faqs',
  help: 'mailto:support@mydra.io?subject=Need%20Assistance%3F%20Leave%20Us%20a%20Message.',
  paymentOptions: 'https://www.mydra.io/payment-options',
}

export const EXTERNAL_LINKS = {
  courseSuggestionForm: 'https://studentfinanceteam.typeform.com/to/ogsYe8ng',
  fixPayFAQ:
    'https://studentfinance.notion.site/FixPay-FAQs-9316a36f023a4ed2b7a54cb053a21c01',
  careerCopilot: 'https://copilot.mydra.io/',
  paymentTerms:
    'https://studentfinance.notion.site/FixPay-FAQs-9316a36f023a4ed2b7a54cb053a21c01',
  linkedIn: 'https://www.linkedin.com/company/studentfinance/',
  forCompanies: 'https://www.mydra.io/for-companies',
  forEducationProviders: 'https://www.mydra.io/education-providers',
  forIndividuals: 'https://www.mydra.io/for-individuals',
  partnerDashboard: import.meta.env.VITE_PUBLIC_PARTNER_DASHBOARD_URL,
  marketplace: import.meta.env.VITE_PUBLIC_MARKETPLACE_HOST_URL,
  playMydra: import.meta.env.VITE_PUBLIC_PLAY_MYDRA_URL,
}

export const PRODUCTS = {
  aiBusiness: 'ai-business',
}

// The trailing group allows an optional query string. Without it a redirect
// target like `/oauth/consent?request_id=…` fails validation and is silently
// dropped, losing the parameter the destination page needs. The query can only
// appear after `?`, so it still cannot introduce a scheme or a
// protocol-relative URL — the open-redirect guard is unchanged.
export const REDIRECT_TO_URL_PATH_REGEX =
  /^(?:\/?(?:en|pt|it|fr|de|es))?\/(?:[a-zA-Z0-9\-._~!$&'()*+,;=:@]+\/?)*(?:\?[a-zA-Z0-9\-._~!$&'()*+,;=:@/?]*)?$/

export const PATH_WITH_SUPPORTED_LOCALES_REGEX = /^\/?(en|pt|it|fr|de|es)(\/|$)/
